<!-- 循环事件设置时间 -->
<template>
    <div class="LoopEventTime" :class="{'RightLoopEventTime': location, 'LeftLoopEventTime': !location}">
      <div class="CustomTime">
        <div class="CustomTimeHead">
          <div class="name">
            {{$t('lang.Custom')}}
          </div>
          <div @click="TimeSelectCancel">
            <i class="iconfont icon-a-closethick"></i>
          </div>
        </div>
        <div class="CustomTimeContent">
          <div class="RepeatScope">
            <div class="RepeatEvery">{{ $t("lang.RepeatEvery") }}</div>
            <div class="Number">
              <input type="number" v-model="RepeatEventMessage.interval" @change="NumberLimit('number')">
              <span class="el-icon-caret-bottom" @click="SubBeforeTime"></span>
              <span class="el-icon-caret-top" @click="AddBeforeTime"></span>
            </div>
            <div class="SelectDate">
              <el-select
              v-model="RepeatEventMessage.customType"
              :placeholder="$t('lang.select')">
                <el-option
                  v-for="(item, index) in DateSelectList"
                  :key="index"
                  :label="$t(`lang.${item}`)"
                  :value="index + 1"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="WeeksSeveral" v-if="RepeatEventMessage.customType == 2">
            <div class="RepeatOn">{{ $t("lang.RepeatOn") }}</div>
            <div class="DayWrap">
              <div class="EveryDay" :class="{ 'ActiveDay': RepeatEventMessage.week.indexOf(index + 1) != -1 }" v-for="(item, index) in AWeek" :key="index" @click="SelectWeekSeveral(index + 1)">
                {{item}}
              </div>
            </div>
          </div>
          <div class="varDayim" v-if="RepeatEventMessage.customType == 3">
            <el-select
              v-model="RepeatEventMessage.monthTypeShow"
              @change="MonthSelect"
              :placeholder="$t('lang.select')">
              <el-option
                v-for="(item, index) in MonthDayList"
                :key="index"
                :label="index ? $t(`lang.${item.value}`, {SeveralFew: $t(`lang.${item.SeveralFew}`), WeeksSeveral: $t(`lang.${item.WeeksSeveral}`)}) : $t(`lang.${item.value}`, {Day: item.Day})"
                :value="index + 1"
              >
              </el-option>
            </el-select>
          </div>
          <div class="EndsMode">
            <div class="Ends">{{ $t("lang.Ends") }}</div>
            <div class="EndsItem Never">
              <el-radio v-model="RepeatEventMessage.endType" :label="1">{{ $t("lang.Never") }}</el-radio>
            </div>
            <div class="EndsItem OnTime">
              <el-radio v-model="RepeatEventMessage.endType" :label="2">{{ $t("lang.On") }}</el-radio>
              <el-date-picker
                :disabled="RepeatEventMessage.endType != 2"
                :class="{ 'radioDisabled': RepeatEventMessage.endType != 2}"
                popper-class="pick_date_timebk"
                v-model="RepeatEventMessage.endTime"
                type="date"
                value-format="timestamp"
                :format="PickerFormat.Date"
              >
              </el-date-picker>
              <i class="el-icon-date"></i>
            </div>
            <div class="EndsItem AfterTime">
              <el-radio v-model="RepeatEventMessage.endType" :label="3">{{ $t("lang.After") }}</el-radio>
              <input type="number" v-model="RepeatEventMessage.occurrences" :disabled="RepeatEventMessage.endType != 3" :class="{ 'radioDisabled': RepeatEventMessage.endType != 3}" @change="NumberLimit('occurrences')">
              <span>{{ $t("lang.occurrences") }}</span>
            </div>
          </div>
        </div>
        <div class="BottomBtn">
          <el-button
            size="small"
            class="cancelButton"
            @click="TimeSelectCancel">{{ $t("lang.cancel") }}</el-button>
          <el-button
            size="small"
            type="primary"
            class="saveButton"
            @click="TimeSelectSave">{{ $t("lang.ConfirmBtn") }}</el-button>
        </div>
      </div>
    </div>
</template>

<script>
import { WeekDayList } from '@/assets/js/common/ParamConfig.js'
export default {
  props: {
    // 选中的事件
    picthOnEvent: {
      type: Object,
      default: () => ({})
    },
    // 循环自定信息
    LoopData: {
      type: Object,
      default: () => ({
        recurType: 0, // 原事件循环类型
        CustomTime: 0, // 循环类型以及显示时间
        isCustom: false, // 是否已选过自定义
        interval: 1, // 第几天
        customType: 1, // 类型
        week: '', // 周几
        monthType: 1, // 月的两种类型
        month: '1', // 月的哪天
        endType: 1, // 结束类型
        end: 0 // 结束时间，次数
      })
    },
    // 位置
    location: {
      type: Boolean,
      default: true // true 右边 false 左边
    }
  },
  data () {
    return {
      // 选择循环周期
      DateSelectList: ['dayKey', 'weekKey', 'monthKey'],
      RepeatEventMessage: {
        interval: 1, // 第几天
        customType: 1, // 类型
        week: '', // 周几
        monthType: 1, // 月的两种类型
        monthTypeShow: '', // 月类型显示
        month: '1', // 月的哪天
        endType: 1, // 结束类型
        endTime: null, // 结束时间
        occurrences: 5 // 结束次数
      },
      // 一周
      AWeek: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
      // 时间格式
      PickerFormat: {
        Date: 'yyyy-MM-dd'
      },
      // 月类型
      MonthDayList: [
        {
          value: 'MonthlyOnDay',
          Day: 2
        },
        {
          value: 'MonthlyOnWeek',
          SeveralFew: 'first',
          WeeksSeveral: 'Monday'
        }
      ],
      // 第几周，周几
      DayWeekList: WeekDayList,
      // 当前时间计算
      currentTime: {
        Day: 1,
        SeveralFew: 1,
        WeeksSeveral: 1
      }
    }
  },
  watch: {
    'picthOnEvent.startTime': {
      handler (value) {
        this.timeCalculation(value)
      },
      immediate: true
    }
  },
  created () {
    this.SettingSelected()
  },
  mounted () {

  },
  methods: {
    // 设置已经选过的值
    SettingSelected () {
      if (this.LoopData.isCustom) {
        const week = this.RepeatEventMessage.week
        this.RepeatEventMessage = {
          ...this.LoopData,
          monthTypeShow: '', // 月类型显示
          endTime: null, // 结束时间
          occurrences: 5 // 结束次数
        }
        if (this.LoopData.customType != 2) {
          this.RepeatEventMessage.week = week
        }
        if (this.LoopData.endType == 2) {
          this.RepeatEventMessage.endTime = this.LoopData.end
        } else if (this.LoopData.endType == 3) {
          this.RepeatEventMessage.occurrences = this.LoopData.end
        }
        this.MonthTypeShow()
      }
    },
    // 时间计算
    timeCalculation (start) {
      if (start) {
        const date = new Date(start)
        const Day = date.getDate()
        let WeeksSeveral = date.getDay()
        const SeveralFew = Math.ceil(Day / 7)
        if (WeeksSeveral == 0) WeeksSeveral = 7
        this.currentTime = {
          Day,
          SeveralFew,
          WeeksSeveral
        }
        if (!this.RepeatEventMessage.week) this.RepeatEventMessage.week = String(WeeksSeveral)
        this.MonthDayList[0].Day = Day
        this.MonthDayList[1].SeveralFew = this.DayWeekList[0][SeveralFew - 1]
        this.MonthDayList[1].WeeksSeveral = this.DayWeekList[1][WeeksSeveral - 1]
      }
    },
    // 数字输入框增加限制
    NumberLimit (key) {
      if (this.RepeatEventMessage[key] < 1) {
        this.RepeatEventMessage[key] = 1
      }
    },
    // 增加时间
    AddBeforeTime () {
      this.RepeatEventMessage.interval++
    },
    // 减少时间
    SubBeforeTime () {
      this.RepeatEventMessage.interval--
      this.NumberLimit('number')
    },
    // 选择周几
    SelectWeekSeveral (index) {
      const week = String(index)
      const WeekList = this.RepeatEventMessage.week.split(',')
      const WeekIndex = WeekList.indexOf(week)
      if (WeekIndex != -1) {
        WeekList.splice(WeekIndex, 1)
      } else {
        WeekList.push(week)
      }
      if (WeekList.length == 0) {
        WeekList.push(String(this.currentTime.WeeksSeveral))
      }
      this.RepeatEventMessage.week = WeekList.join(',')
    },
    // 月类型选择
    MonthSelect (key) {
      if (key == 1) {
        this.RepeatEventMessage.monthType = key
        this.RepeatEventMessage.month = String(this.currentTime.Day)
      } else {
        this.RepeatEventMessage.monthType = key
        this.RepeatEventMessage.month = `${this.currentTime.SeveralFew},${this.currentTime.WeeksSeveral}`
      }
      this.MonthTypeShow()
    },
    // 月类型显示转换
    MonthTypeShow () {
      const LoopShowData = this.RepeatEventMessage
      if (LoopShowData.customType == 3) {
        if (LoopShowData.monthType == 1) {
          this.RepeatEventMessage.monthTypeShow = this.$t('lang.MonthlyOnDay', { Day: LoopShowData.month })
        } else if (LoopShowData.monthType == 2) {
          const SeveralFew = this.DayWeekList[0][this.currentTime.SeveralFew - 1]
          const WeeksSeveral = this.DayWeekList[1][this.currentTime.WeeksSeveral - 1]
          this.RepeatEventMessage.monthTypeShow = this.$t('lang.MonthlyOnWeek', { SeveralFew: this.$t(`lang.${SeveralFew}`), WeeksSeveral: this.$t(`lang.${WeeksSeveral}`) })
        }
      }
    },
    // 时间选择取消
    TimeSelectCancel () {
      this.$emit('CustomTimeSelect', {
        type: 0
      })
    },
    // 时间选择保存
    TimeSelectSave () {
      if (this.RepeatEventMessage.endType == 2 && !this.RepeatEventMessage.endTime) {
        this.$message.warning(this.$t('lang.CustomTimeSelect'))
      } else {
        const RepeatEventMessage = JSON.parse(JSON.stringify(this.RepeatEventMessage))
        RepeatEventMessage.interval = Number(RepeatEventMessage.interval)
        if (RepeatEventMessage.endType == 2) {
          RepeatEventMessage.end = Number(RepeatEventMessage.endTime)
        } else if (RepeatEventMessage.endType == 3) {
          RepeatEventMessage.end = Number(RepeatEventMessage.occurrences)
        } else {
          RepeatEventMessage.end = 0
        }
        this.$emit('CustomTimeSelect', {
          type: 1,
          TimeShow: RepeatEventMessage
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.LoopEventTime{
  position: absolute;
  top: 0;
  .CustomTime{
    background: #252525;
    width: 369px;
    padding: 0 24px 24px;
    text-align: left;
    border-radius: 6px;
    color: #DBDBDB;
    font-size: 14px;
    .CustomTimeHead{
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 2px solid #444444;
    }
    .CustomTimeContent{
      ::v-deep .el-input__inner{
        height: 32px;
        line-height: 32px;
      }
      .RepeatScope {
        display: flex;
        justify-content: space-between;
        margin-top: 16px;
        .Number{
          position: relative;
          margin: 0 3px;
          .el-icon-caret-top{
            position: absolute;
            right: 9px;
            top: 4px;
            font-size: 15px;
            color: #999999;
            cursor: pointer;
          }
          .el-icon-caret-bottom{
            position: absolute;
            right: 9px;
            bottom: 4px;
            font-size: 15px;
            color: #999999;
            cursor: pointer;
          }
        }
        .SelectDate{
          width: 128px;
          ::v-deep .el-input__inner{
            height: 32px;
            line-height: 32px;
          }
        }
      }
      .WeeksSeveral{
        margin-top: 20px;
        .DayWrap{
          display: flex;
          margin-top: 10px;
          .EveryDay{
            width: 28px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            background: #444444;
            border-radius: 20px;
            color: #666666;
            margin-right: 6px;
            cursor: pointer;
          }
          .ActiveDay{
            background: #33AB4F;
            color: #FFFFFF;
          }
        }
      }
      .varDayim{
        margin-top: 23px;
        width: 260px;
        ::v-deep .el-input__inner{
          width: 260px;
        }
      }
      .EndsMode{
        margin-top: 20px;
        .EndsItem{
          height: 32px;
          margin-top: 8px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .radioDisabled{
            opacity: .5;
            cursor: not-allowed;
          }
        }
        .OnTime{
          position: relative;
          ::v-deep .el-date-editor{
            .el-input__inner{
              border: none;
              width: 219px;
              height: 32px;
              background: #444444;
              padding-left: 10px;
              padding-right: 30px
            }
            .el-input__prefix{
              display: none;
            }
            .el-input__suffix{
              right: 23px;
            }
          }
          .el-icon-date{
            position: absolute;
            right: 8px;
            top: 8px;
          }
        }
        .AfterTime{
          position: relative;
          input{
            width: 218px;
            padding-right: 97px;
          }
          span {
            position: absolute;
            right: 8px;
            top: 5px;
          }
        }
      }
      .Number,.AfterTime {
        input{
          width: 70px;
          height: 32px;
          outline: none;
          background: #444444;
          border: none;
          color: #dbdbdb;
          padding-left: 8px;
          padding-right: 25px;
          border-radius: 4px;
          line-height: 32px;
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
        input[type='number'] {
          -moz-appearance: textfield;
        }
      }
    }
    .BottomBtn{
      text-align: right;
      margin-top: 40px;
      button {
        width: 80px;
        height: 32px;

      }
    }
  }
}
.RightLoopEventTime{
  left: 103%;
}
.LeftLoopEventTime{
  right: 103%;
}
</style>
